import(/* webpackMode: "eager" */ "/vercel/path0/src/components/layout/content-wrapper/content-wrapper.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/layout/navbar/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/components/layout/section-layout/section-layout.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/layout/transaction-pending-indicator/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/providers/crypto.provider.tsx");
